/* Header scroll effect */
(function(){
  var h = document.getElementById('site-header');
  if(!h) return;
  window.addEventListener('scroll', function(){
    h.classList.toggle('scrolled', window.scrollY > 20);
  }, {passive:true});
})();

/* Mobile nav toggle */
(function(){
  var btn = document.getElementById('mobile-menu-btn');
  var nav = document.getElementById('mobile-nav');
  var overlay = document.getElementById('mobile-overlay');
  var closeBtn = document.getElementById('mobile-nav-close');
  if(!btn || !nav) return;
  function openNav(){ nav.classList.add('open'); if(overlay) overlay.classList.add('open'); document.body.style.overflow='hidden'; }
  function closeNav(){ nav.classList.remove('open'); if(overlay) overlay.classList.remove('open'); document.body.style.overflow=''; }
  btn.addEventListener('click', openNav);
  if(closeBtn) closeBtn.addEventListener('click', closeNav);
  if(overlay) overlay.addEventListener('click', closeNav);
  nav.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', closeNav); });
})();

/* Popup primera compra */
(function(){
  var STORAGE_KEY = 'vetera_popup_v2';
  var COUNTDOWN_SECS = 15 * 60;

  var popup   = document.getElementById('discount-popup');
  var timerEl = document.getElementById('popup-timer');
  var copyBtn = document.getElementById('popup-copy-btn');
  var codeEl  = document.getElementById('popup-code-text');

  if(!popup) return;
  if(localStorage.getItem(STORAGE_KEY)) return;

  var openTimer, countdownInterval, secondsLeft;

  function openPopup() {
    popup.classList.add('visible');
    document.body.style.overflow = 'hidden';
    startCountdown();
    popup.focus();
  }

  function closePopup() {
    popup.classList.remove('visible');
    document.body.style.overflow = '';
    localStorage.setItem(STORAGE_KEY, '1');
    clearTimeout(openTimer);
    clearInterval(countdownInterval);
  }

  function startCountdown() {
    secondsLeft = COUNTDOWN_SECS;
    clearInterval(countdownInterval);
    countdownInterval = setInterval(function() {
      secondsLeft--;
      var m = Math.floor(secondsLeft / 60);
      var s = secondsLeft % 60;
      if(timerEl) {
        timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        timerEl.classList.toggle('urgent', secondsLeft <= 60);
      }
      if(secondsLeft <= 0) closePopup();
    }, 1000);
  }

  function copyCode() {
    var code = codeEl ? codeEl.textContent.trim() : 'PRIMERA10';
    if(navigator.clipboard) {
      navigator.clipboard.writeText(code).then(showCopied);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      ta.style.cssText = 'position:fixed;opacity:0';
      document.body.appendChild(ta);
      ta.focus(); ta.select();
      try { document.execCommand('copy'); } catch(e){}
      document.body.removeChild(ta);
      showCopied();
    }
  }

  function showCopied() {
    if(!copyBtn) return;
    copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> ¡Copiado!';
    copyBtn.classList.add('copied');
    setTimeout(function(){
      copyBtn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Copiar';
      copyBtn.classList.remove('copied');
    }, 2500);
  }

  /* bind events — single source, no duplicates */
  document.getElementById('popup-close').addEventListener('click', closePopup);
  document.getElementById('popup-skip').addEventListener('click', closePopup);
  if(copyBtn) copyBtn.addEventListener('click', copyCode);
  popup.addEventListener('click', function(e){ if(e.target === popup) closePopup(); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && popup.classList.contains('visible')) closePopup(); });

  /* close popup when navigating to collections via CTA (keep code in clipboard) */
  var ctaBtn = document.getElementById('popup-cta');
  if(ctaBtn) ctaBtn.addEventListener('click', function(){
    copyCode();
    closePopup();
  });

  openTimer = setTimeout(openPopup, 3500);
})();

/* Add to cart */
function addToCart(variantId, btn) {
  var orig = btn.innerHTML;
  btn.innerHTML = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg> Agregando…';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type':'application/json'},
    body: JSON.stringify({id: parseInt(variantId), quantity: 1})
  })
  .then(function(r){ if(!r.ok) throw new Error(); return r.json(); })
  .then(function(){
    btn.innerHTML = '<svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg> ¡Agregado!';
    btn.style.background = 'var(--green-light)';
    return fetch('/cart.js').then(function(r){ return r.json(); });
  })
  .then(function(cart){
    var badge = document.getElementById('cart-count-badge');
    if(badge) badge.textContent = cart.item_count;
    setTimeout(function(){
      btn.innerHTML = orig;
      btn.style.background = '';
      btn.disabled = false;
    }, 2200);
  })
  .catch(function(){
    btn.innerHTML = orig;
    btn.style.background = '';
    btn.disabled = false;
  });
}

/* ── Search overlay ── */
(function(){
  var overlay = document.getElementById('search-overlay');
  var openBtn = document.getElementById('search-open-btn');
  var closeBtn = document.getElementById('search-close');
  var input = document.getElementById('search-input');
  if(!overlay || !openBtn) return;

  function openSearch(){
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function(){ if(input) input.focus(); }, 80);
  }
  function closeSearch(){
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  openBtn.addEventListener('click', openSearch);
  if(closeBtn) closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', function(e){ if(e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && overlay.classList.contains('open')) closeSearch();
    if((e.ctrlKey || e.metaKey) && e.key === 'k'){ e.preventDefault(); openSearch(); }
  });

  /* Search tag click fills input */
  document.querySelectorAll('.search-tag').forEach(function(tag){
    tag.addEventListener('click', function(){
      if(input){ input.value = tag.textContent; input.focus(); }
    });
  });
})();

/* ── Back to top ── */
(function(){
  var btn = document.getElementById('back-top');
  if(!btn) return;
  window.addEventListener('scroll', function(){
    btn.classList.toggle('show', window.scrollY > 500);
  }, {passive:true});
  btn.addEventListener('click', function(){
    window.scrollTo({top:0, behavior:'smooth'});
  });
})();

/* ── FAQ accordion ── */
function toggleFaq(btn) {
  var item = btn.closest('.faq-item');
  var isOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item.open').forEach(function(i){ i.classList.remove('open'); });
  if(!isOpen) item.classList.add('open');
}

